<template>
  <template v-if="isAdmin">
      <button class="button slightly-rounded m-2" @click="onClick()">
          <span>Share File</span>
          <span class="icon">
              <i class="fa-solid fa-share-from-square"></i>
          </span>
      </button>
  </template>
</template>

<script>
import { codeB64 } from '@/js/codeValidator'

export default {
    name: 'ShareFileButton',
    props: { isAdmin: Boolean, fileId: String },
    methods: {
        onClick() {
            const currentUrl = window.location.href
            const url = `${currentUrl}&code=${this.generateCode()}`
            navigator.clipboard.writeText(url)
            window.alert(`Share URL copied to clipboard \nValid for 72hrs`)
        },
        generateCode() {
            return codeB64.encode(`${this.fileId},${new Date()}`)
        }
    }
}
</script>

